import { AbstractControl, FormArray, FormControl, FormGroup, UntypedFormGroup } from '@angular/forms';

export class ClaroFormGroup extends UntypedFormGroup {
    markAsDirtyAndUpdateAll(): void {
        const walk = (ctrl: AbstractControl) => {
            if (ctrl instanceof FormControl) {
                ctrl.markAsDirty();
                ctrl.updateValueAndValidity();
                return;
            }

            if (ctrl instanceof FormGroup) {
                Object.values(ctrl.controls).forEach(walk);
            } else if (ctrl instanceof FormArray) {
                ctrl.controls.forEach(walk);
            }

            ctrl.markAsDirty();
            ctrl.updateValueAndValidity();
        };

        walk(this);
    }
}
